import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  MapPin,
  Phone,
  Mail,
  Clock,
  Send,
  MessageCircle,
  Building2,
} from "lucide-react";
import { sendHtmlEmail } from "../emailapi";
const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    course: "",
    message: "",
    terms: false,
  });
  const [loading, setLoading] = useState(false);
  const contactInfo = [
    {
      icon: <MapPin size={22} />,
      title: "College Address",
      text: "Village & Post Arangi, District Chandauli, Uttar Pradesh - 232110",
    },
    {
      icon: <Phone size={22} />,
      title: "Phone Number",
      text: "+91-9451887217, +91-9450181867",
    },
    {
      icon: <Mail size={22} />,
      title: "Email Address",
      text: "psndwivedi@gmail.com",
    },
    {
      icon: <Clock size={22} />,
      title: "Office Hours",
      text: "Monday to Saturday, 10:00 AM - 4:00 PM",
    },
  ];
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.terms) {
      alert("Please accept the Terms & Conditions.");
      return;
    }
    const emailData = {
      name: formData.name,
      phone: formData.phone,
      email: formData.email,
      course: formData.course,
      message: formData.message,
    };
    try {
      setLoading(true);
      await sendHtmlEmail("admin@gmail.com", "New Enquiry", emailData);
      alert("Your enquiry has been submitted successfully!");
      setFormData({
        name: "",
        phone: "",
        email: "",
        course: "",
        message: "",
        terms: false,
      });
    } catch (error) {
      console.error("Email sending failed:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <section className="w-full bg-[#F6F8FC] py-12 md:py-16 overflow-hidden">
      <div className="w-full px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center max-w-3xl mx-auto mb-10"
          >
            <span className="inline-flex items-center gap-2 bg-[#071A52] text-[#FFD700] px-5 py-2 rounded-full text-xs font-black uppercase tracking-wide mb-4 shadow">
              <Building2 size={15} />
              Contact Us
            </span>
            <h2 className="text-3xl md:text-4xl font-black text-[#071A52] leading-tight">
              Get in Touch With Our College
            </h2>
            <div className="w-24 h-1.5 bg-[#FFD700] rounded-full mx-auto mt-4 mb-4"></div>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed">
              For admission, course details, and college-related information,
              feel free to contact us.
            </p>
          </motion.div>
          <div className="grid lg:grid-cols-12 gap-8 items-stretch">
            <motion.div
              initial={{ opacity: 0, x: -35 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.65 }}
              viewport={{ once: true }}
              className="lg:col-span-5"
            >
              <div className="h-full bg-gradient-to-br from-[#071A52] via-[#0B1F5C] to-[#102B75] rounded-[30px] p-6 md:p-8 shadow-xl relative overflow-hidden">
                <div className="absolute -top-16 -right-16 w-52 h-52 bg-[#FFD700]/20 rounded-full blur-3xl"></div>
                <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-white/10 rounded-full blur-3xl"></div>

                <div className="relative z-10">
                  <h3 className="text-2xl md:text-3xl font-black text-white mb-3">
                    Contact Information
                  </h3>
                  <p className="text-white/75 text-sm leading-relaxed mb-7">
                    Reach out to the college office for admission queries,
                    academic information, and general support.
                  </p>
                  <div className="space-y-4">
                    {contactInfo.map((item, index) => (
                      <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 18 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.45, delay: index * 0.08 }}
                        viewport={{ once: true }}
                        className="flex gap-4 bg-white/10 border border-white/15 rounded-2xl p-4 backdrop-blur-md"
                      >
                        <div className="w-12 h-12 rounded-xl bg-[#FFD700] text-[#071A52] flex items-center justify-center shrink-0">
                          {item.icon}
                        </div>
                        <div>
                          <h4 className="text-white font-black text-sm mb-1">
                            {item.title}
                          </h4>
                          <p className="text-white/75 text-sm leading-relaxed">
                            {item.text}
                          </p>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                  <div className="mt-7 flex flex-col sm:flex-row gap-3">
                    <a
                      href="tel:+91+91-9451887217"
                      className="inline-flex items-center justify-center gap-2 bg-[#FFD700] text-[#071A52] px-5 py-3 rounded-xl text-sm font-black hover:bg-white transition-all"
                    >
                      <Phone size={17} />
                      Call Now
                    </a>
                    <a
                      href="mailto:psndwivedi@gmail.com"
                      className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/25 text-white px-5 py-3 rounded-xl text-sm font-black hover:bg-white hover:text-[#071A52] transition-all"
                    >
                      <Mail size={17} />
                      Email Us
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 35 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.65 }}
              viewport={{ once: true }}
              className="lg:col-span-7"
            >
              <div className="h-full bg-white rounded-[30px] p-6 md:p-8 shadow-xl border border-gray-100">
                <div className="mb-6">
                  <h3 className="text-2xl md:text-3xl font-black text-[#071A52]">
                    Send Your Enquiry
                  </h3>
                  <p className="text-gray-600 text-sm mt-2">
                    Fill the form below and our team will contact you soon.
                  </p>
                </div>
                <form onSubmit={handleSubmit} className="space-y-5">
                  <div className="grid md:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-sm font-bold text-[#071A52] mb-2">
                        Full Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="Enter your name"
                        className="w-full bg-[#F6F8FC] border border-gray-200 rounded-xl px-4 py-3 text-sm outline-none focus:border-[#071A52] focus:ring-2 focus:ring-[#071A52]/10 transition-all"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-bold text-[#071A52] mb-2">
                        Mobile Number
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        placeholder="Enter mobile number"
                        className="w-full bg-[#F6F8FC] border border-gray-200 rounded-xl px-4 py-3 text-sm outline-none focus:border-[#071A52] focus:ring-2 focus:ring-[#071A52]/10 transition-all"
                      />
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-sm font-bold text-[#071A52] mb-2">
                        Email Address
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Enter email address"
                        className="w-full bg-[#F6F8FC] border border-gray-200 rounded-xl px-4 py-3 text-sm outline-none focus:border-[#071A52] focus:ring-2 focus:ring-[#071A52]/10 transition-all"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-bold text-[#071A52] mb-2">
                        Course Interested
                      </label>
                      <select
                        name="course"
                        value={formData.course}
                        onChange={handleChange}
                        required
                        className="w-full bg-[#F6F8FC] border border-gray-200 rounded-xl px-4 py-3 text-sm outline-none focus:border-[#071A52] focus:ring-2 focus:ring-[#071A52]/10 transition-all"
                      >
                        <option value="">Select Course</option>
                        <option value="B.A.">B.A.</option>
                        <option value="B.Com">B.Com</option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-[#071A52] mb-2">
                      Message
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="5"
                      required
                      placeholder="Write your message..."
                      className="w-full bg-[#F6F8FC] border border-gray-200 rounded-xl px-4 py-3 text-sm outline-none focus:border-[#071A52] focus:ring-2 focus:ring-[#071A52]/10 transition-all resize-none"
                    ></textarea>
                  </div>
                  <div className="flex items-start gap-3 bg-[#F6F8FC] border border-gray-200 rounded-xl p-4">
                    <input
                      type="checkbox"
                      name="terms"
                      checked={formData.terms}
                      onChange={handleChange}
                      required
                      className="mt-1 h-4 w-4 accent-[#071A52] shrink-0 cursor-pointer"
                    />
                    <label className="text-sm text-gray-700 leading-relaxed">
                      I agree to the{" "}
                      <a
                        href="/terms"
                        className="text-[#071A52] font-bold hover:text-[#D4A017]"
                      >
                        Terms & Conditions
                      </a>{" "}
                      and allow the college team to contact me regarding my
                      enquiry.
                    </label>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-4">
                    <button
                      type="submit"
                      disabled={loading}
                      className="inline-flex items-center justify-center gap-2 bg-[#071A52] text-[#FFD700] px-7 py-3 rounded-xl text-sm font-black hover:bg-[#FFD700] hover:text-[#071A52] transition-all shadow-md disabled:opacity-60 disabled:cursor-not-allowed"
                    >
                      <Send size={17} />
                      {loading ? "Sending..." : "Submit Enquiry"}
                    </button>
                    <a
                      href="https://wa.me/91+91-9451887217"
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center justify-center gap-2 bg-[#F6F8FC] text-[#071A52] border border-gray-200 px-7 py-3 rounded-xl text-sm font-black hover:bg-[#071A52] hover:text-white transition-all"
                    >
                      <MessageCircle size={17} />
                      WhatsApp
                    </a>
                  </div>
                </form>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ContactSection;